<template>
  <div class="payment-list">
    <!-- 搜索区域 -->
    <div class="search-wrapper">
      <el-form :model="searchForm" ref="searchForm" size="small" label-width="100px">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="所属代理商">
              <el-input v-model="searchForm.agentThreeName" placeholder="请输入所属代理商" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="网卡卡号">
              <el-input v-model="searchForm.cardId" placeholder="请输入卡号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="虚拟号">
              <el-input v-model="searchForm.phone" placeholder="请输入虚拟号" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="网卡套餐">
              <el-input v-model="searchForm.mealName" placeholder="请输入网卡套餐" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="开卡公司">
              <el-select v-model="searchForm.accountName" placeholder="请选择" style="width: 100%">
                <el-option label="全部" value=""></el-option>
                <el-option v-for="item in companies" 
                  :key="item.value" 
                  :label="item.label" 
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="支付状态">
              <el-select v-model="searchForm.payStatusStr" placeholder="全部" style="width: 100%">
                <el-option label="全部" value=""></el-option>
                <el-option label="已支付" value="已支付"></el-option>
                <el-option label="未支付" value="未支付"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="下单时间">
              <el-date-picker
                v-model="searchForm.timeRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24" style="text-align: left">
            <el-button type="primary" @click="handleSearch">查询</el-button>
            <el-button type="success" @click="handleExport">导出excel</el-button>
            <el-button @click="resetForm('searchForm')">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table-wrapper">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        v-loading="loading">
        <el-table-column prop="orderNumber" label="订单号" align="center"></el-table-column>
        <el-table-column prop="agentThreeName" label="代理商层级" align="center"></el-table-column>
        <el-table-column prop="accountName" label="运营商账号" align="center"></el-table-column>
        <el-table-column prop="typeStr" label="运营商类型" align="center"></el-table-column>
        <el-table-column prop="cardId" label="卡号" align="center"></el-table-column>
        <el-table-column prop="transactionId" label="交易单号" align="center"></el-table-column>
        <el-table-column prop="phone" label="接入号" align="center"></el-table-column>
        <el-table-column prop="vcode" label="虚拟号" align="center"></el-table-column>
        <el-table-column prop="costPrice" label="成本价" align="center"></el-table-column>
        <el-table-column prop="fandianMoney" label="返点金额" align="center"></el-table-column>
        <el-table-column prop="mfAmount" label="秒返金额" align="center"></el-table-column>
        <el-table-column prop="noMfAmount" label="未秒返金额" align="center"></el-table-column>
       <el-table-column prop="mealName" label="套餐名称" align="center"></el-table-column>
        <el-table-column prop="effectTypeStr" label="次月生效" align="center"></el-table-column>
        <el-table-column prop="mealTypeStr" label="套餐类型" align="center"></el-table-column>
        <el-table-column prop="createTime" label="下单时间" align="center"></el-table-column>
        <el-table-column prop="payStatusStr" label="支付状态" align="center"></el-table-column>
        <el-table-column prop="payMethodStr" label="支付方式" align="center"></el-table-column>
        <el-table-column prop="orderSourceStr" label="来源" align="center"></el-table-column>
        <el-table-column prop="orderMoney" label="订购金额" align="center"></el-table-column>
        <el-table-column prop="orderCount" label="订购数量" align="center"></el-table-column>
        <el-table-column prop="isFirstRechargeStr" label="是否首充" align="center"></el-table-column>
        <el-table-column label="操作" width="150" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="handleRefund(scope.row)">申请退款</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrapper">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchForm.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="searchForm.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'PaymentList',
  data() {
    return {
      // 搜索表单
      searchForm: {
        agentThreeName: '',
        cardId: '',
        phone: '',
        mealName: '',
        accountName: '',
        payStatusStr: '',
        timeRange: [],
        page: 1,
        pageSize: 10
      },
      // 表格数据
      tableData: [],
      // 总条数
      total: 0,
      // 加载状态
      loading: false,
      // 公司选项
      companies: [
        { value: '广电1', label: '广电1' },
        { value: 'GD物联', label: 'GD物联' }
      ]
    }
  },
  methods: {
    // 获取列表数据
    async getList() {
      this.loading = true
      try {
        // 从localStorage获取token
        const token = localStorage.getItem('token')
        
        const response = await axios({
          method: 'post',
          url: 'http://192.168.0.108:8080/api/api/v1/kf-refound/order-list',
          headers: {
            'Authorization': `Bearer ${token}`
          },
          data: {
            page: this.searchForm.page,
            pageSize: this.searchForm.pageSize,
            cardId: this.searchForm.cardId,
            agentThreeName: this.searchForm.agentThreeName,
            phone: this.searchForm.phone,
            mealName: this.searchForm.mealName,
            accountName: this.searchForm.accountName,
            payStatusStr: this.searchForm.payStatusStr,
            startTime: this.searchForm.timeRange ? this.searchForm.timeRange[0] : '',
            endTime: this.searchForm.timeRange ? this.searchForm.timeRange[1] : ''
          }
        })
        
        if (response.data && response.data.data) {
          this.tableData = response.data.data
          this.total = response.data.total || 0
        }
      } catch (error) {
        console.error('获取订单列表失败:', error)
        // 根据错误类型显示不同的错误提示
        if (error.response) {
          switch (error.response.status) {
            case 401:
              this.$message.error('登录已过期，请重新登录')
              break
            case 403:
              this.$message.error('没有权限访问')
              break
            default:
              this.$message.error('获取订单列表失败')
          }
        } else {
          this.$message.error('获取订单列表失败')
        }
      } finally {
        this.loading = false
      }
    },
    // 搜索
    handleSearch() {
      this.searchForm.page = 1
      this.getList()
    },
    // 导出
    handleExport() {
      // 实现导出功能
      this.$message.info('导出功能开发中')
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields()
      this.handleSearch()
    },
    // 分页大小改变
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.getList()
    },
    // 页码改变
    handleCurrentChange(val) {
      this.searchForm.page = val
      this.getList()
    },
    // 申请退款
    handleRefund(row) {
      this.$router.push({
        path: '/refund/godaddy',
        query: {
          orderNo: row.orderNumber,
          agentName: row.agentThreeName,
          cardNo: row.cardId,
          packageName: row.mealName,
          orderTime: row.orderMoney,
          source: row.orderSourceStr,
          createTime: row.createTime

        }
      })
    }
  },
  created() {
    this.getList()
  }
}
</script>

<style scoped>
.payment-list {
  padding: 20px;
  background: #fff;
}

.search-wrapper {
  padding: 20px;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  margin-bottom: 20px;
}

.table-wrapper {
  margin-top: 20px;
  overflow-x: auto;
}

.pagination-wrapper {
  margin-top: 20px;
  text-align: right;
}

/* 调整表单项样式 */
:deep(.el-form-item) {
  margin-bottom: 18px;
}

:deep(.el-form-item__label) {
  color: #606266;
  font-weight: normal;
}

/* 调整按钮间距 */
.el-button + .el-button {
  margin-left: 10px;
}

/* 调整表格样式 */
:deep(.el-table th) {
  background-color: #f5f7fa;
  color: #606266;
  font-weight: 500;
  text-align: center;
}

:deep(.el-table td) {
  padding: 8px 0;
}

/* 调整操作按钮的间距 */
:deep(.el-button--text) {
  padding: 0 5px;
}

/* 给表格添加hover效果 */
:deep(.el-table--enable-row-hover .el-table__body tr:hover > td) {
  background-color: #f5f7fa;
}
</style> 